
export const API_URLS = {

  // changed
  login: 'merchants/login',
  signUp: 'merchants/signup',
  otp_ver: 'merchants/verify-otp',
  otp_resend: 'merchants/send-otp',
  add_device_token: 'merchants/devices/add',

  // Total Outlets & managers
  //resturant
  add_restro_info: 'merchants/restaurants/add-details',
  update_restro_info: "merchants/restaurants/update-details",
  add_restro_slot: 'merchants/slots/add',
  delete_slot: 'merchants/slots/delete-all',

  add_restro_menu: 'merchants/restaurants/add-images',

  get_retro_detail: 'merchants/restaurants/get-details',
  update_restro_slot: 'merchants/slots/update',
  get_review_list: 'merchants/reviews/restaurants',
  perform_review_action: 'merchants/reviews/restaurants',
  webview_action: 'app/config',

  booking_list: "merchants/reservations/list",
  update_booking_status: 'merchants/reservations/status',
  cancel_booking_list: 'merchants/reservations/cancellation/reasons',
  slot_details_list:'merchants/slots/booking-details',
  booking_no_show: 'api/v1/merchants/users/no-show',
  update_restro_policy: 'merchants/restaurants/update-details',
  cussines_Data: 'merchants/restaurants/categories/list?is_paginated=false',
  dining_data: 'merchants/restaurants/dinnings/list?is_paginated=false',
  amenities_data: 'merchants/restaurants/amenities/list?is_paginated=false',
  remove_images: 'merchants/restaurants/remove-images',
  slot_close: 'merchants/slots/close',
  reopen_slots: 'merchants/slots/open',
  get_dashboard_list: 'merchants/restaurants/dashboard',
  send_reply: 'merchants/reviews/reply',
  operational_hours: 'merchants/restaurants/operational-hours',
  add_types_timings: 'merchants/restaurants/add-types-timings',
  get_slot_list: 'merchants/slots/list/v1',
  get_closed_slot_list: 'merchants/slots/close',
  add_slot_advance_operational: 'merchants/slots/add-advance',
  update_password: 'merchants/update-password',
  reset_password: 'merchants/reset-password',
  update_single_restro_slot: 'merchants/slots/single-slot',
  get_14_slot_list: 'merchants/slots/weekly',
  country_list: 'merchants/country-list',
  location_list: 'merchants/locations/list?is_paginated=false&keyword&from_date&to_date&city_id&country_id=',
  social_login: 'merchants/social-login',
  logout: "merchants/logout"
};
